(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lhaptic-in-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lhaptic-motion-player')) {
    customElements.define('lhaptic-motion-player', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        const video = this.querySelector('video');
        const button = this.querySelector('.lhaptic-motion__play');
        if (!video || !button) return;
        this.dataset.initialized = 'true';
        button.addEventListener('click', () => {
          video.muted = false;
          video.play().catch(() => { button.hidden = false; });
        });
        video.addEventListener('play', () => { button.hidden = true; });
        video.addEventListener('ended', () => { button.hidden = false; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
